import React from "react";

const Disclaimer = () => {
  return (
    <div className="terms-container">
      <h1>Disclaimer</h1>

      <p>
        The information provided on this website is for general
        informational purposes only.
      </p>

      <h3>Accuracy of Information</h3>
      <p>
        While Transcare Agencies strives to keep information accurate and
        up to date, we make no guarantees about the completeness or
        reliability of the information.
      </p>

      <h3>External Links</h3>
      <p>
        Our website may contain links to external websites. We are not
        responsible for the content or policies of these third-party
        websites.
      </p>

      <h3>Limitation of Liability</h3>
      <p>
        Transcare Agencies will not be liable for any damages arising from
        the use of this website.
      </p>
    </div>
  );
};

export default Disclaimer;